import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function LearningDisabilityView() {
  useDocumentTitle('Learning Disability-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-20'}
        title={'Learning Disability'}
        link={''}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container ">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                The right level of support to meet your needs
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">T</span>he daily lives of
                  many individuals who have learning disabilities can be
                  impacted in a number of different ways. The degree of
                  assistance we offer depends on the needs and preferences of
                  the individual and can range from mild to severe, depending on
                  the learning impairment.
                </p>
                <p className="values_p3">
                  Our service provides qualified support staff and healthcare
                  assistants committed to helping children, adolescents, and
                  adults with a range of learning disabilities live their best
                  lives. Our person-centered methodology promotes real
                  interaction and connections. We strive for greater inclusion,
                  freedom, and choice for our clients so they can have more
                  control over their lives.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/brain-injury">
                        Brain injury
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/spinal-injury">
                        Spinal injury
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/neurological-conditions">
                        Neurological conditions
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Creating your bespoke package of care
                </h2>
                <p className="white-color">
                  We will work with family members and multidisciplinary teams
                  to design a customized package of care that addresses your
                  clinical, social, and personal needs.
                </p>
                <p className="white-color">
                  Along with the emotional and social support aspects of
                  everyday life, we take the practical and clinical aspects of
                  our clients' care into account. Due to our extensive expertise
                  in providing complex care in the home, we are well-equipped to
                  assist our clients and their families.
                </p>
                <p className="white-color">
                  Our registered nurses are credentialed with the Nursing and
                  Midwifery Council and have extensive training and experience
                  in their area of specialization. (NMC). They can use their
                  clinical decision-making abilities to make sure that the care
                  plan for our customers changes to meet their evolving need
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">The way we support you</h2>
                <p>
                  Our highly trained healthcare assistants provide the
                  following:
                </p>
                <div>
                  <ul className="care_bullets-2">
                    <li>Support for multiple clinical needs.</li>
                    <li className="">
                      Support with all activities of daily living, including
                      personal care.
                    </li>
                    <li>Help towards independence with personal care tasks.</li>
                    <li>
                      Help with the use of technology to assist with
                      independence.
                    </li>
                    <li>
                      {' '}
                      Help with attending social and educational settings.
                    </li>
                    <li>
                      Prevention and intervention of behaviors that pose
                      challenges.
                    </li>
                    <li>
                      Discovering new hobbies, getting out and having fun.
                    </li>
                  </ul>
                </div>
                <p>
                  We have extensive expertise in providing complex care in the
                  community because most of the clients we look after have
                  severe learning disabilities also known as profound and
                  multiple learning disabilities (PMLD). A person with PMLD
                  would have additional impairments or medical requirements that
                  would seriously impair their capacity for independence and
                  communication.
                </p>
                <p>
                  PMLD can occur in both children and adults with a broad
                  variety of diseases. We deal with people who have cerebral
                  palsy, epilepsy, profound and multiple learning disabilities,
                  Down syndrome, and autistic spectrum disorders. Many patients
                  need suctioning, oxygen, or tube nutrition.
                </p>
                <p>
                  Some of our clients are said to have illnesses that are
                  "life-limiting." Others may be more vulnerable to illnesses
                  like gastroenteritis and lung infections because of their
                  weakened health.
                </p>
                <p>
                  Many of the PMLD patients we care for don't use traditional
                  forms of communication like speech, symbols, or signs. They
                  frequently use body language, vocalizations, facial
                  expressions, and behavior to interact. To interpret responses
                  and determine the best ways to engage, our staff spends time
                  becoming familiar with these communication methods.
                </p>
                <p>
                  We have extensive experience creating customized care plans
                  that can both meet your clinical requirements and encourage
                  freedom, empowerment, and choice.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">What a learning disability is</h2>
                <p className="white-color">
                  A learning disability affects a person for the rest of their
                  life and results in diminished intellectual ability and
                  difficulties with daily chores like housework, socializing, or
                  money management.
                </p>
                <p className="white-color">
                  {' '}
                  A learning disability causes people to learn more slowly and
                  they may need assistance to interact with others, acquire new
                  skills, and comprehend complex material.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default LearningDisabilityView;
